module.exports = __webpack_public_path__ + "static/media/I.56fbfbc3.svg";